import { render, staticRenderFns } from "./ImsImportInventoryAccountModal.vue?vue&type=template&id=1ba1daa2&"
import script from "./ImsImportInventoryAccountModal.vue?vue&type=script&lang=js&"
export * from "./ImsImportInventoryAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports